
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7023/api/',
    //Live

    //DEV
   

    // Demo
    apiUrl: 'https://dr-api.solegaze.com/api/',

    apiKey: 'Lieda1002',
};

export default apiConfig;

